import * as React from 'react';

function NotCleanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 19.25q-.021 0-.039-.004l1.399-3.856h6.506l-1.5-1.5H5.265l-.02-.003-.078-.004-.082-.013v-.357c0-.098.046-.234.207-.364s.413-.222.708-.222h3.728l-1.488-1.5H6c-.588 0-1.185.18-1.648.553-.464.373-.768.92-.768 1.533v.45a1.36 1.36 0 0 0 .62 1.129l-1.386 3.826-.014.042c-.07.232-.072.478-.008.712s.188.436.348.598c.159.163.351.283.554.362s.42.118.636.118H17.56l-2.58-2.575.335 1.075h-6.63l.532-1.708a.75.75 0 0 0-1.433-.445l-.67 2.153zm15.372-.004q-.018.003-.038.004h-1.483l1.5 1.5.144-.007q.244-.022.474-.111c.203-.08.396-.2.555-.362s.284-.365.347-.598c.064-.234.062-.48-.008-.712l-.013-.042-1.388-3.826q.05-.034.098-.072a1.36 1.36 0 0 0 .523-1.057v-.45c0-.614-.304-1.16-.767-1.533-.464-.372-1.06-.553-1.649-.553h-3.75a.3.3 0 0 1-.08-.012V3.75a.75.75 0 0 0-1.5 0v7.755c0 .425.204.804.52 1.058.301.242.683.364 1.06.364H18c.296 0 .547.093.708.222.161.13.208.267.208.364v.357l-.083.013a1 1 0 0 0-.097.007h-5.917l1.515 1.5h3.974zM10.58 3a.75.75 0 0 0-.75.75v7.148l1.303 1.301a1.3 1.3 0 0 0 .197-.694V3.75a.75.75 0 0 0-.75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 21.81 2.25 3.31l1.06-1.06 18.5 18.5z"
  }));
}

export { NotCleanIcon };
